/**
 * Puts the app's scrolling region back to the top.
 *
 * WHY THIS IS A SHARED HELPER AND NOT `querySelector('.overflow-y-auto')`. That is what the client
 * profile used, and it never worked: the sidebar nav also carries `overflow-y-auto` and sits FIRST
 * in the DOM, so every "scroll to top" between fact-find steps scrolled the navigation instead of
 * the page. Nobody noticed because the nav is usually already at its top, so the call appeared to be
 * a harmless no-op rather than a miss. Reported as landing mid-page (2026-08-22).
 *
 * The scroll container is marked with `data-app-scroll-container` in MainAppLayout, so this targets
 * the one element that actually scrolls. The window is scrolled too: layouts that let the document
 * scroll instead (and the standalone pages that render outside the shell) need that, and on a layout
 * where the window never scrolls it costs nothing.
 */
export const APP_SCROLL_CONTAINER_ATTR = 'data-app-scroll-container';

export function scrollAppToTop(behavior: ScrollBehavior = 'smooth'): void {
    if (typeof document === 'undefined') return;

    const container = document.querySelector(`[${APP_SCROLL_CONTAINER_ATTR}]`);
    if (container) container.scrollTo({ top: 0, behavior });
    if (typeof window !== 'undefined') window.scrollTo({ top: 0, behavior });
}
